// extracted by mini-css-extract-plugin
export var fieldTable = "style-module--field-table--QnB03";
export var horizontal = "style-module--horizontal--i4eEU";
export var overflow = "style-module--overflow--E8Dtb";
export var required = "style-module--required--Nx6er";
export var root = "style-module--root--Btdah";
export var table = "style-module--table--AFynn";
export var vertical = "style-module--vertical--e0SDR";